
import React from 'react';
import { Loader2 } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  icon?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  isLoading, 
  icon, 
  className = '', 
  ...props 
}) => {
  const baseStyles = "flex items-center justify-center gap-2 rounded-md font-bold uppercase tracking-wider transition-all active:scale-95 disabled:opacity-50 disabled:active:scale-100 shadow-sm";
  
  const sizes = {
    sm: "px-3 py-1.5 text-[9px]",
    md: "px-5 py-2.5 text-[10px]",
    lg: "px-8 py-4 text-xs"
  };

  const variants = {
    primary: "bg-[#FFDB00] text-black hover:bg-[#F5D100] border border-transparent",
    secondary: "bg-slate-900 text-white hover:bg-black border border-transparent",
    danger: "bg-rose-600 text-white hover:bg-rose-700 border border-transparent",
    ghost: "bg-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-900 shadow-none border border-transparent",
    outline: "bg-white border border-slate-200 text-slate-900 hover:border-slate-400"
  };

  return (
    <button 
      className={`${baseStyles} ${sizes[size]} ${variants[variant]} ${className}`}
      disabled={isLoading || props.disabled}
      {...props}
    >
      {isLoading ? <Loader2 size={14} className="animate-spin" /> : icon}
      {children}
    </button>
  );
};
